var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOrderDescBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4643 59.8221L73.4402 53.3906L73.4402 92.4555C73.4402 95.7903 75.8749 98.4105 78.9735 98.4105C82.0722 98.4105 84.5068 95.7903 84.5068 92.4555L84.5068 53.3906L90.4827 59.8221C92.6961 62.2041 96.1267 62.2041 98.34 59.8221C100.553 57.4401 100.553 53.7479 98.34 51.3659L82.8468 34.811C81.7402 33.62 80.3015 33.0245 78.9735 33.0245C77.6455 33.0245 76.0962 33.62 75.1002 34.811L59.7177 51.3659C57.5044 53.6288 57.5044 57.4401 59.7177 59.8221C61.8203 62.085 65.3616 62.2041 67.4643 59.8221Z",
    fill: "#113251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7265 15.5914L7.53381 15.5914C3.31652 15.5914 0.00292969 12.3949 0.00292969 8.32654C0.00292969 4.2582 3.31652 1.06165 7.53381 1.06165L66.7265 1.06165C70.9438 1.06165 74.2574 4.2582 74.2574 8.32654C74.2574 12.3949 70.9438 15.5914 66.7265 15.5914Z",
    fill: "#113251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56087 33.0276L51.8504 33.0276C56.0828 33.0276 59.4083 36.2243 59.4083 40.2927C59.4083 44.3612 56.0828 47.5579 51.8504 47.5579L7.56087 47.5579C3.32842 47.5579 0.00292969 44.3612 0.00292969 40.2927C0.00292969 36.2243 3.32842 33.0276 7.56087 33.0276Z",
    fill: "#113251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57722 66.4445L36.9768 66.4445C41.2201 66.4445 44.554 69.6412 44.554 73.7096C44.554 77.7781 41.2201 80.9747 36.9768 80.9747L7.57722 80.9747C3.33398 80.9747 0 77.7781 0 73.7096C0 69.6412 3.33398 66.4445 7.57722 66.4445Z",
    fill: "#113251"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrderDescBlue);
export default __webpack_public_path__ + "static/media/icon-order-desc-blue.0b695cc41326ec3f3aafc45bd6fe1a16.svg";
export { ForwardRef as ReactComponent };